import { Batch } from '../../entyties/batch/model/types';

export function getCompositeKey(batch: Batch): string {
  const purchaseOrder = 'purchaseOrderNumber' in batch ? batch.purchaseOrderNumber : '';

  const batchLevel = 'batchLevel' in batch ? batch.batchLevel : '';

  const parentBatch = 'parentBatch' in batch ? batch.parentBatch : '';
  const parentMaterial = 'parentMaterial' in batch ? batch.parentMaterial : '';

  return [
    batch.id,
    batch.batchId,
    batch.materialId,
    batch.materialDescription,
    batch.plantCode,
    batch.rootPlant ?? '',
    batch.rootMaterial ?? '',
    batch.rootBatch ?? '',
    batchLevel,
    purchaseOrder,
    parentBatch,
    parentMaterial,
  ].join('|');
}
